import { type AlertsWidgetBaseState, type AlertsWidgetStoreState } from './types';

export const ALERTS_STORE_NAME = 'navigation-alerts-store';

const ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';

export const PredefinedQueries = {
	MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${ONLY_MY_SELECTOR_QUERY}`,
	MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${ONLY_MY_SELECTOR_QUERY}`,
	MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${ONLY_MY_SELECTOR_QUERY}`,
};

export const initialState: AlertsWidgetStoreState = {};

export const baseState: AlertsWidgetBaseState = {
	items: null,
	isFetching: false,
	fetchError: null,
	hasFetchedOnce: false,
	hasSuccessOnce: false,
	totalCount: 0,
};

export const GLOBAL_ALERTS_ROUTE_NAME = 'eoc-global-alerts';
export const GLOBAL_ALERT_DETAIL_ROUTE_NAME = 'eoc-global-alert-detail';
